import { gql } from 'graphql-tag';

import {
  AT_IMAGE_FRAGMENT,
  SEO_FRAGMENT,
  BENEFIT_FRAGMENT,
  BENEFITS_CONTAINER_FRAGMENT,
  FAQ_CONTAINER_FRAGMENT,
  FAQ_FRAGMENT,
  RESOURCE_FRAGMENT,
  SOCIAL_PROOF_FRAGMENT,
  STATISTIC_FRAGMENT,
  OR_VIDEO_FRAGMENT,
  MARKETING_CONTENT_BLOCK_FRAGMENT,
  HERO_FRAGMENT,
  ENTRY_LAYOUT_FRAGMENT,
  ASSOCIATED_CONTENT_RESOURCES_COLLECTION_FRAGMENT,
  IMAGE_CONTENT_BLOCK_FRAGMENT,
  AT_LINK_FRAGMENT,
  UI_FLOATING_IMAGE_BLOCK_FRAGMENT,
  UI_FULL_WIDTH_IMAGE_BLOCK_FRAGMENT,
} from 'src/graphql/fragments/fragments';
import { GetFlexibleContentHubCollectionQuery } from 'src/graphql/generated/graphql';

export const GET_FLEXIBLE_CONTENT_HUB_COLLECTION = gql`
  ${SEO_FRAGMENT}
  ${AT_IMAGE_FRAGMENT}
  ${AT_LINK_FRAGMENT}
  ${UI_FLOATING_IMAGE_BLOCK_FRAGMENT}
  ${UI_FULL_WIDTH_IMAGE_BLOCK_FRAGMENT}
  ${BENEFIT_FRAGMENT}
  ${BENEFITS_CONTAINER_FRAGMENT}
  ${STATISTIC_FRAGMENT}
  ${FAQ_CONTAINER_FRAGMENT}
  ${FAQ_FRAGMENT}
  ${RESOURCE_FRAGMENT}
  ${SOCIAL_PROOF_FRAGMENT}
  ${OR_VIDEO_FRAGMENT}
  ${MARKETING_CONTENT_BLOCK_FRAGMENT}
  ${IMAGE_CONTENT_BLOCK_FRAGMENT}
  ${ENTRY_LAYOUT_FRAGMENT}
  ${HERO_FRAGMENT}
  ${ASSOCIATED_CONTENT_RESOURCES_COLLECTION_FRAGMENT}
  query getFlexibleContentHubCollection($preview: Boolean!, $type: String!, $slug: String) {
    flexibleContentHubCollection(limit: 1, preview: $preview, where: { type: $type, slug: $slug }) {
      __typename
      items {
        sys {
          id
        }
        nameInternal
        titleExternal
        type
        slug
        hero {
          ...GetHeroFragment
        }
        contentContainerCollection(limit: 100, preview: $preview, where: { sys: { id_exists: true } }) {
          items {
            ... on BenefitsContainer {
              ...GetBenefitsContainerFragment
            }
            ... on Statistic {
              ...GetStatisticFragment
            }
            ... on MarketingContentBlock {
              ...GetMarketingContentBlockFragment
            }
            ... on ImageContentBlock {
              ...GetImageContentBlockFragment
            }
            ... on UiFullWidthImageBlock {
              ...GetUiFullWidthImageBlockFragment
            }
            ... on UiFloatingImageBlock {
              ...GetUiFloatingImageBlockFragment
            }
            ... on MlNavtab {
              __typename
              sys {
                id
              }
              tabColors
              tabsLabel
              title
              description
              contentCollection(limit: 100, preview: $preview, where: { sys: { id_exists: true } }) {
                __typename
                items {
                  ... on MlAccordion {
                    __typename
                    iconType
                    tabsLabel
                    tabsContentCollection(limit: 100, preview: $preview, where: { sys: { id_exists: true } }) {
                      items {
                        __typename
                        ... on Expander {
                          expandedContent {
                            json
                          }
                          description {
                            json
                          }
                          title
                          resourcesCollection {
                            items {
                              ... on AssociatedContent {
                                __typename
                                sys {
                                  id
                                }
                                tag
                                nameInternal
                                title: titleExternal
                                description
                                link {
                                  ...GetAtLinkFragment
                                }
                                asset {
                                  ...AtImageFragment
                                }
                              }
                            }
                          }
                        }
                        ... on ReusableContentSection {
                          __typename
                          contentSectionTitle {
                            __typename
                            contentSectionTitleExternal
                            contentSectionSubtitle
                            contentSectionSubtitleRichText {
                              json
                              links {
                                entries {
                                  inline {
                                    ...EntryLayoutFragment
                                  }
                                  block {
                                    ...EntryLayoutFragment
                                  }
                                }
                              }
                            }
                          }
                          contentLinksCollection(limit: 100, preview: $preview, where: { sys: { id_exists: true } }) {
                            __typename
                            items {
                              ... on AssociatedContent {
                                __typename
                                sys {
                                  id
                                }
                                tag
                                nameInternal
                                title: titleExternal
                                description
                                link {
                                  ...GetAtLinkFragment
                                }
                                asset {
                                  ...AtImageFragment
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            ... on SocialProof {
              ...GetSocialProofFragment
            }
            ... on FaqContainer {
              ...GetFAQContainerFragment
            }
            ... on OrVideo {
              sys {
                id
              }
              ...OrVideoFragment
            }
            ... on Resource {
              ...GetResourceFragment
            }
          }
        }
        seo {
          ...SeoFragment
        }
      }
    }
  }
`;

export type GetFlexibleContentHubCollectionResponse = GetFlexibleContentHubCollectionQuery;
export type ContentfulFlexibleContentHub =
  GetFlexibleContentHubCollectionResponse['flexibleContentHubCollection']['items'][0];
export type ContentContainersCollection = ContentfulFlexibleContentHub['contentContainerCollection']['items'];
